// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { NgClass, NgStyle } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../../helpers/_old_helpers/overlayHelperClass';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { InputTextRoundedComponent } from '../input-text-rounded/input-text-rounded.component';

@Component({
  selector: 'lbca-select-rounded',
  templateUrl: './select-rounded.component.html',
  styleUrl: './select-rounded.component.scss',
  imports: [InputTextRoundedComponent, CdkPortal, NgClass, NgStyle],
})
export class SelectRoundedComponent implements AfterViewInit {
  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;

  private errorPopup!: ErrorOverlayClass;
  private selectOverlay!: OverlayHelper;
  public setError;

  public hasError: boolean = false;
  public errorFeedback: any;
  public componetHelperIconStyle: any = null;

  public dataInput: any;
  private option: any[] = [];
  private valUnsorted: any[] = [];
  public optionRestored: any[] = [];
  public optionFiltered: any[] = [];
  public chosed: boolean = false;
  public autoSort: boolean = true;

  public labelValue: string = '';
  public helperTextValue: string = '';
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public isLabeled: boolean = false;
  public isTabeled: boolean = false;
  public isEditable: boolean = false;
  public isReadOnly: boolean = false;
  public isLoading = false;

  public isShowErrorPopup: boolean = true;

  private restoRestoreValueInput: any = null;
  private valueSelected: any = null;
  public errorList: any = null;
  public valueInput: any = null;
  public componetIconSize: 'normal' | 'sm' | 'lg' = 'normal';

  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set showErrorPopup(value: boolean) {
    this.isShowErrorPopup = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set readonly(read: boolean) {
    this.isReadOnly = read;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set data(value: any) {
    this.dataInput = value;
  }
  @Input() set loadingState(value: any) {
    this.isLoading = value;
  }

  @Input() set dataSave(value: any) {
    if (this.valueSelected && value) {
      this.saveOption();
    }
  }

  @Input('sort')
  set sortItens(order: boolean) {
    if (order !== undefined && order !== null) {
      this.autoSort = order;
      this.option = [...this.optionRestored];
    }
  }

  @Input('options')
  set optionsList(val: any) {
    if (!val) return;

    const valSorted = this.autoSort ? val.sort((a, b) => a.label.localeCompare(b.label)) : val;
    this.option = [...valSorted];
    this.optionFiltered = [...valSorted];
    if (this.valueSelected) {
      const select = this.option.find((opt) => opt.value === this.valueSelected);
      this.componetIconStyle = 'svg-icon-check bg-primary transition duration-400 ease-in-out';
      if (select) this.valueInput = select.label;

      this.restoRestoreValueInput = this.valueInput;
    }
    this.calcHeightProp();
  }
  @Input() set value(value: string) {
    if (value) {
      this.valueSelected = value;
      if (this.valueSelected) {
        const select = this.option.find((opt) => opt.value === this.valueSelected);
        this.componetIconStyle = 'svg-icon-check bg-primary transition duration-400 ease-in-out';
        if (select) this.valueInput = select.label;

        this.restoRestoreValueInput = this.valueInput;
      }
    } else {
      if (this.isReadOnly) this.valueInput = '-';
    }
  }

  @Input('error')
  set err(error: any) {
    // this.errorFeedback = error;

    if (error && error.length > 0) {
      this.setError = error;
      error.forEach((element) => {
        element === 'upload_error'
          ? (this.errorFeedback = ['Oops.. erro no upload. Tente novamente'])
          : null;
      });

      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.setError = null;
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Output('tryActionAgain') tryAgainEmitter = new EventEmitter();
  @Output() focusState = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('changeLabelValue') changeLabelEmmiter = new EventEmitter();
  @Output('errorState') setErrorEmmiter = new EventEmitter();
  @Output('validState') setValidEmmiter = new EventEmitter();
  @Output('saveEnable') saveEnableEmmiter = new EventEmitter();

  public bindProperties: any = {
    width: 320,
    height: 240,
  };

  public componetIconStyle = 'svg-icon-angle bg-primary transition duration-400 ease-in-out';

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    this.selectOverlay = new OverlayHelper(overlay);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'end'
    );
  }

  ngAfterViewInit(): void {
    const wid = this.calcWidth();
    const mainElementWid = Math.round(
      this.mainElement!.nativeElement.getBoundingClientRect().width
    );

    this.bindProperties.width = wid > mainElementWid ? wid : mainElementWid;

    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      offsetY: 16,
      connectedTo: this.mainElement!,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };

    this.selectOverlay.setConfiguration(config);
  }

  public tryAgain($event) {
    this.tryAgainEmitter.emit(true);
  }

  public changeEvent($event: any): void {
    if (!this.chosed) {
      $event.target.value = '';
      this.valueInput = '';
    }
  }

  private calcWidth() {
    const body = document.body,
      html = document.documentElement;

    const maxWindowSize = Math.max(
      body.scrollWidth,
      body.offsetWidth,
      html.clientWidth,
      html.scrollWidth,
      html.offsetWidth
    );

    let maiorLen = 0;
    this.option.forEach((item) => {
      if (item.label.length > maiorLen) maiorLen = item.label.length;
    });
    const calc = maiorLen * 5;

    return calc > maxWindowSize ? maxWindowSize : calc;
  }

  public selectOption($event: MouseEvent, option: any): void {
    if (this.optionFiltered.includes(option)) {
      this.chosed = true;
      this.valueInput = option.label;
      this.valueSelected = option.value;
      this.saveEnableEmmiter.emit(this.valueSelected);
      this.setValidEmmiter.emit(true);
      this.setErrorEmmiter.emit([]);
    } else {
      this.setValidEmmiter.emit(false);
    }
  }

  public saveOption(): void {
    if (!this.valueSelected) {
      this.setValidEmmiter.emit(false);
      return;
    }

    this.labeled = false;
    this.componetIconSize = 'normal';
    this.componetIconStyle = 'svg-icon-check transition duration-400 ease-in-out';
    this.changeEmmiter.emit(this.valueSelected);
    this.changeLabelEmmiter.emit(this.valueInput);
    this.setValidEmmiter.emit(true);
    this.setErrorEmmiter.emit([]);
  }

  private calcHeightProp(): void {
    const length = this.optionFiltered.length;

    let size = 220;

    if (length >= 5) size = 220;
    else if (length === 1) size = 44;
    else if (length === 0) size = 32;
    else size = length * 44;

    this.bindProperties.height = size;
  }

  public click() {
    if (this.isReadOnly) return;
    const focusedElement = document.activeElement;
    if (focusedElement instanceof HTMLInputElement) {
      this.componetIconStyle =
        'svg-icon-angle bg-primary transition duration-400 ease-in-out rotate-180';
      this.openSelectBox();
    }
  }

  public setFocus(focus: any): void {
    if (this.errorFeedback || !this.dataInput?.editLabel || this.isReadOnly) return;

    this.focusState.emit(focus);
    this.componetIconSize = 'normal';
    if (focus) {
      this.labeled = true;
      this.chosed = false;
      // this.valueInput = '';
      this.componetIconStyle = 'svg-icon-angle transition duration-400 ease-in-out rotate-180';
      this.openSelectBox();
    } else {
      this.componetIconStyle = 'svg-icon-angle transition duration-400 ease-in-out';
      this.closeSelectBox();
      if (!this.chosed) {
        this.valueInput = '';
        this.optionFiltered = [...this.option];
        this.calcHeightProp();
      } else {
        this.componetIconStyle = 'button-ok';
      }
    }
  }

  private openSelectBox(): void {
    if (this.isReadOnly) return;
    this.chosed = false;
    // this.valueInput = '';
    this.selectOverlay.show(this.templateAppend);
    if (this.isShowErrorPopup) {
      this.errorPopup.setFocus(true);
    }
  }

  private closeSelectBox(): void {
    setTimeout(() => {
      this.selectOverlay.close();
      if (this.restoRestoreValueInput && this.valueInput === '') {
        this.valueInput = this.restoRestoreValueInput;
        this.saveOption();
      }
      this.errorPopup.setFocus(false);
    }, 150);
  }

  public setErrorControllEmmiter($event) {
    this.setErrorEmmiter.emit($event);
  }

  setClick($event) {
    $event.preventDefault();
  }

  public inputKeyUpEvent($event) {
    const value = $event.target.value;
    if (value !== '') {
      this.optionFiltered = this.option.filter((item) => {
        return RegExp(value, 'ig').test(item.label);
      });
      this.calcHeightProp();

      return this.optionFiltered;
    }
    this.optionFiltered = [...this.option];
    this.calcHeightProp();
    return this.optionFiltered;
  }
}
